import filters from '../vue/filters';

export default {
    computed: {
        isProrate() {
            return Boolean(this.prorate);
        },

        lines() {
            return this.prorate.lines;
        },

        linesPlanAmount() {
            const item = this.prorate.lines.find((item) => item.key === 'plan');

            if (item) {
                return item.amount;
            }

            return this.prorate.remaining_amount;
        },

        linesSeatAmount() {
            const item = this.prorate.lines.find((item) => item.key === 'seat');

            if (!item) return 0;

            return item.amount;
        },

        linesInboxAmount() {
            const item = this.prorate.lines.find((item) => item.key === 'inbox');

            if (!item) return 0;

            return item.amount;
        },

        linesComplianceAmount() {
            const item = this.prorate.lines.find((item) => item.key === 'compliance');

            if (!item) return 0;

            return item.amount;
        },

        linesCustomDomainAmount() {
            const item = this.prorate.lines.find((item) => item.key === 'custom_domain');

            if (!item) return 0;

            return item.amount;
        },

        hasCoupon() {
            if (!this.isProrate) return false;

            return Boolean(this.prorate.discount_amount > 0);
        },

        percentCoupon() {
            if (!this.isProrate) return false;

            const coupon = this.prorate.coupon;

            if (coupon.currency === 'usd') {
                return filters.currency(this.prorate.discount, 2);
            }

            return `${this.prorate.discount}%`;
        },

        percentDiscountTotal() {
            return filters.currency(this.prorate.discount_amount * -1, 2);
        },

        couponMessage() {
            const coupon = this.prorate.coupon;
            let discountText = '';
            if (coupon.amount_off) {
                discountText +=
                    coupon.currency === 'usd'
                        ? filters.currency(coupon.amount_off, 2)
                        : coupon.amount_off / 100 + ' ' + coupon.currency;
            } else if (coupon.percent_off) {
                discountText += coupon.percent_off + '%';
            }

            return `🎉Coupon applied! Enjoy <strong>${discountText} off</strong> next month.`;
        },

        today() {
            return moment().format('MMMM Do, YYYY');
        },
    },
};
